import PropTypes from "prop-types";
import { formatSimplePrice } from "../helpers";

const SearchMapMarker = ({ price, onClick, isSelected, viewed }) => {
  let markerStateStyles = "tw-bg-white tw-border-gray-30 before:tw-border-t-[#c2c2c2] after:tw-top-[95%] after:tw-border-t-white";

  if (isSelected) {
    markerStateStyles = "tw-bg-theme-primary tw-border-theme-primary before:tw-border-t-theme-primary after:tw-top-full after:tw-border-t-theme-primary";
  } else if (viewed) {
    markerStateStyles = "tw-bg-gray-15 tw-border-gray-15 before:tw-border-t-[#c2c2c2] after:tw-top-full after:tw-border-t-[#e0e0e0]";
  }

  const markerClassName = `
    tw-relative tw-flex tw-cursor-pointer tw-justify-center tw-items-center tw-px-8px tw-py-3px tw-rounded-666px
    tw-border-1px tw-border-solid tw-shadow-[0px_6px_20px_rgba(51,51,51,0.16)]
    before:tw-content-[''] before:tw-block before:tw-absolute before:tw-h-0 before:tw-w-0 before:tw-border-solid before:tw-border-transparent before:tw-top-full before:tw-border-[7px]
    after:tw-content-[''] after:tw-block after:tw-absolute after:tw-h-0 after:tw-w-0 after:tw-border-solid after:tw-border-transparent after:tw-border-[7px]
    ${markerStateStyles}
  `;

  return (
    <button type="button" onClick={onClick} className={markerClassName}>
      <span
        className={`tw-text-14px tw-font-sans tw-font-semibold ${
          isSelected ? "tw-text-white" : "tw-text-gray-75"
        }`}
      >
        {formatSimplePrice(price) || "N/A"}
      </span>
    </button>
  );
};

SearchMapMarker.propTypes = {
  price: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  viewed: PropTypes.bool.isRequired,
};

export default SearchMapMarker;
